module.exports = __webpack_public_path__ + "img/not-found.3ace0f10.png";